module.exports = __webpack_public_path__ + "img/history.53fdbb84.jpg";